import classNames from "classnames";
import { ToggleSwitchProps } from "./types";
import classes from "./ToggleSwitch.module.scss";

export const ToggleSwitch = ({ label, onChange, checked }: ToggleSwitchProps) => {
    return (
        <label className={classes["toggle-switch"]}>
            <input
                type="checkbox"
                className={classes["toggle-switch__input"]}
                checked={checked}
                onChange={onChange}
                aria-label={label}
            />
            <span
                className={classNames(classes["toggle-switch__slider"], {
                    [classes["toggle-switch__slider--active"]]: checked
                })}
            ></span>
            <span className={classes["toggle-switch__label"]}>{label}</span>
        </label>
    );
};